// Define types for gtag parameters
type GtagParams = {
  page_location: string;
  page_path: string;
  [key: string]: string | number | boolean;
};

// Add type declaration for gtag
declare global {
  interface Window {
    gtag: (command: string, action: string, params?: GtagParams) => void;
  }
}

export const Analytics = {
  lastPageViewed: "",
  // Utility function to send page views
  trackPageView() {
    const currentPage = window.location.pathname + window.location.search;

    // Only send page view if it's a new page
    if (currentPage !== this.lastPageViewed) {
      window.gtag?.("event", "page_view", {
        page_location: currentPage,
        page_path: currentPage,
      });
      this.lastPageViewed = currentPage;
    }
  },
  // Utility function to send custom events
  trackEvent(eventName: string, parameters?: Record<string, string | number | boolean>) {
    if (window.gtag) {
      console.log('Analytics trackEvent:', eventName);
      const gtagParams = parameters ? { ...parameters } : {};
      window.gtag("event", eventName, gtagParams as Parameters<typeof window.gtag>[2]);
    }
  },
};
